import './index.css'
import cn from 'clsx'
import get from 'lodash/get'
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import type { Contact, RecipientList } from 'types/list'
import type { State } from 'types/redux'
import {
  getBatchMode,
  getContactsSavingStatus,
  makeGetContact,
} from '@disco/state-management/selectors/contacts'
import { getContactStatus } from '@disco/utils/contacts'
import { parseSearchQuery } from '@disco/utils/string-utils'
import ActionButton from 'components/ui/action-button'
import HighlighedText from 'components/ui/highlighted-text'
import Input from 'components/ui/input'
const emptyArray = []

const mapStateToProps = (state: State, props: any): any => {
  const getContact = makeGetContact()
  const contact = getContact(state, {
    contactId: props.contactId,
    list: props.list,
    appendingContacts: props.appendingContacts,
  })
  return {
    contact,
    saving: getContactsSavingStatus(state),
    batchMode: contact && contact.editMode ? getBatchMode(state) : undefined,
  }
}

class ContactRow extends React.Component<{
  // TODO: Fix type
  columns: any
  contactId: number
  list: RecipientList
  appendingContacts?: boolean
  contact: Contact
  searchTerm: string
  saving: boolean
  onRowModeSwitch: (...args: Array<any>) => any
  onFieldChange: ((...args: Array<any>) => any) | null | undefined
  onFieldValueAdd: ((...args: Array<any>) => any) | null | undefined
  onFieldValueRemove: ((...args: Array<any>) => any) | null | undefined
  onSelect: ((...args: Array<any>) => any) | null | undefined
  batchMode: boolean | null | undefined
}> {
  _onSwitch = () => this.props.onRowModeSwitch(this.props.contact, false)

  render() {
    const {
      columns,
      contact,
      searchTerm,
      onFieldChange,
      saving,
      appendingContacts,
      batchMode,
      onSelect,
      onRowModeSwitch,
    } = this.props
    if (!contact) return null

    const getPendingChangesValue = (key: string) =>
      get(contact, `pendingChanges.${key}`, contact[key] || '')

    const isEditable = ({ editable, batchEditable }) =>
      batchEditable === false ? editable && !batchMode : editable

    const className = cn('ContactRow', {
      'is-selected': !!contact.selected,
    })
    const searchTerms = parseSearchQuery(searchTerm)
    const contactStatus = getContactStatus(
      contact,
      this.props.list && this.props.list.id,
    )
    let disabled, unsubscribeTooltip

    switch (contactStatus) {
      case '2_UNSUBSCRIBE_ALL':
        unsubscribeTooltip = 'Unsubscribed from all emails'
        if (appendingContacts) disabled = true
        break

      case '1_UNSUBSCRIBED_THIS':
        unsubscribeTooltip = 'Unsubscribed from this list'
        if (appendingContacts) disabled = true
        break

      case '0_SUBSCRIBED':
        unsubscribeTooltip = 'Subscribed'
        disabled = false
        break
    }

    return (
      <div
        className={cn(className, {
          ContactRow_Disabled: disabled,
          'ContactRow--edit-mode': contact.editMode,
        })}
      >
        {columns.map(column => {
          if (!column) return null
          const key = `row-${column.label}`
          const className = `ContactCell ContactCell_${column.value}`
          return (
            <div
              key={key}
              className={className}
              onClick={() => {
                if (!contact.editMode && onSelect && column.label !== 'Tags') {
                  onSelect(contact)
                }
              }}
            >
              {contact.editMode && onFieldChange && isEditable(column) ? (
                <Input
                  className="Form_Input"
                  name={column.id}
                  value={getPendingChangesValue(column.id)}
                  onChange={e =>
                    onFieldChange(contact, e.target.name, e.target.value)
                  }
                />
              ) : column.renderData ? (
                column.renderData(contact)
              ) : (
                <Link
                  className="ContactCell_Link"
                  to={`/contacts/${contact.id}`}
                >
                  <HighlighedText
                    text={contact[column.id]}
                    highlights={searchTerms}
                  />
                </Link>
              )}
            </div>
          )
        })}
        {onRowModeSwitch && (
          <div className="ContactCell ContactCell_Action">
            <ActionButton
              disabled={Boolean(contact.referenced_business)}
              size="24px"
              icon="pen"
              activeIcon="check-circle"
              activeIconColor="#5f63ee"
              activeMode={contact.editMode}
              inProgressMode={contact.editMode && saving}
              inProgressIcon="spinner"
              inProgressColor="#ccc"
              onClick={this._onSwitch}
            />
          </div>
        )}
      </div>
    )
  }
}

export default connect(mapStateToProps)(ContactRow) as any
